module.exports = __webpack_public_path__ + "static/assets/4d5b695c10c7ab9a61f216ade8771b02.png";